import { useLingui } from "@lingui/react/macro";
import Image from "next/image";

interface Props {
	className?: string;
	width?: number;
	height?: number;
}

export default function GoogleGIcon(props: Props) {
	const { t } = useLingui();
	return (
		<Image
			src="/svg/google-g-icon.svg"
			alt={t`Google G Icon`}
			width={props.width ?? 16}
			height={props.height ?? 16}
			className={props.className}
		/>
	);
}
